import { styled } from '@mui/material/styles';
import { Avatar, Box, TableCell, TableRow } from '@mui/material';

export const MessageTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'isRejected' && prop !== 'isSelected'
})<{ isRejected?: boolean; isSelected?: boolean }>(
  ({ theme, isRejected, isSelected }) => ({
    cursor: 'pointer',
    backgroundColor: isRejected
      ? theme.palette.error.light + '15'
      : isSelected
      ? theme.palette.primary.light + '10'
      : 'transparent',
    '&:hover': {
      backgroundColor: isRejected
        ? theme.palette.error.light + '25'
        : theme.palette.action.hover
    }
  })
);

export const DetailRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'isExpanded'
})<{ isExpanded?: boolean }>(({ isExpanded }) => ({
  display: isExpanded ? 'table-row' : 'none'
}));

export const DetailCell = styled(TableCell)(({ theme }) => ({
  paddingTop: 0,
  paddingBottom: theme.spacing(2),
  borderBottom: 'none'
}));

export const EmployeeAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  fontSize: '0.75rem',
  backgroundColor: theme.palette.primary.light
}));

export const EmployeeCell = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8
});

export const ActionsCell = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  flexWrap: 'nowrap'
});

export const NoteText = styled(Box)({
  maxWidth: 150,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

export const DetailContent = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}));
